import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useDeliveryItemContext } from "../../../context/deliveryItem.context";
import { formatPriceForEcommerce } from "../../../deliveryItem.base";

const DeliveryCostComponent = () => {
    const { t } = useGranite();
    const {
        option,

        montageParents
    } = useDeliveryItemContext();

    if (montageParents.length !== 0) {
        return null;
    }

    return (
        <div
            data-test={`deliveryItem-${option.deliveryType}-deliveryCost`}
            className={cn("tw:flex tw:justify-end")}
        >
            <p
                className={cn(
                    "tw:font-bold tw:m-0 tw:text-right tw:whitespace-nowrap"
                )}
            >
                {option.deliveryCost === 0
                    ? t(
                          `general.ecommerce.deliveryCost.free.${option.deliveryType}`
                      )
                    : formatPriceForEcommerce(option.deliveryCost)}
            </p>
        </div>
    );
};

export { DeliveryCostComponent };
